// NOTE: This Obj should be merged with PageProductSeries
import * as Scrivito from "scrivito";
import categoriesProducts from "config/locals/keysCategoriesProducts.json";
import defaultPageAttributes from "objs/_defaultPageAttributes";
import metadataAttributes from "objs/_metadataAttributes";

const ProductSeries = Scrivito.provideObjClass("ProductSeries", {
  attributes: {
    ...defaultPageAttributes,
    azListDisabled: ["enum", { values: ["Yes", "No"] }],
    azListTitle: "string",
    complementaryText: "html",
    extendedMultitabBox1HiddenMobile: ["enum", { values: ["Yes", "No"] }],
    extendedMultitabBox1Tab1Image: ["referencelist", { only: ["Image"] }],
    extendedMultitabBox1Tab1Text: "html",
    extendedMultitabBox1Tab1Title: "string",
    extendedMultitabBox1Tab2Image: ["referencelist", { only: ["Image"] }],
    extendedMultitabBox1Tab2Text: "html",
    extendedMultitabBox1Tab2Title: "string",
    extendedMultitabBox1Tab3Image: ["referencelist", { only: ["Image"] }],
    extendedMultitabBox1Tab3Text: "html",
    extendedMultitabBox1Tab3Title: "string",
    extendedMultitabBox1Tab4Image: ["referencelist", { only: ["Image"] }],
    extendedMultitabBox1Tab4Text: "html",
    extendedMultitabBox1Tab4Title: "string",
    extendedMultitabBox1Tab5Image: ["referencelist", { only: ["Image"] }],
    extendedMultitabBox1Tab5Text: "html",
    extendedMultitabBox1Tab5Title: "string",
    extendedMultitabBox1Tab6Image: ["referencelist", { only: ["Image"] }],
    extendedMultitabBox1Tab6Text: "html",
    extendedMultitabBox1Tab6Title: "string",
    extendedMultitabBox0Title: "string",
    extendedMultitabBox1Title: "string",
    extendedMultitabBox2HiddenMobile: ["enum", { values: ["Yes", "No"] }],
    extendedMultitabBox2Tab1Image: ["referencelist", { only: ["Image"] }],
    extendedMultitabBox2Tab1Text: "html",
    extendedMultitabBox2Tab1Title: "string",
    extendedMultitabBox2Tab2Image: ["referencelist", { only: ["Image"] }],
    extendedMultitabBox2Tab2Text: "html",
    extendedMultitabBox2Tab2Title: "string",
    extendedMultitabBox2Tab3Image: ["referencelist", { only: ["Image"] }],
    extendedMultitabBox2Tab3Text: "html",
    extendedMultitabBox2Tab3Title: "string",
    extendedMultitabBox2Tab4Image: ["referencelist", { only: ["Image"] }],
    extendedMultitabBox2Tab4Text: "html",
    extendedMultitabBox2Tab4Title: "string",
    extendedMultitabBox2Tab5Image: ["referencelist", { only: ["Image"] }],
    extendedMultitabBox2Tab5Text: "html",
    extendedMultitabBox2Tab5Title: "string",
    extendedMultitabBox2Tab6Image: ["referencelist", { only: ["Image"] }],
    extendedMultitabBox2Tab6Text: "html",
    extendedMultitabBox2Tab6Title: "string",
    extendedMultitabBox2Title: "string",
    filterApplication: [
      "multienum",
      {
        values: [
          "architecture_and_design",
          "comfort_areas",
          "door_installation",
          "extract_air",
          "extract_and_supply_air",
          "floor_installation",
          "for_great_room_heights",
          "pipe_installation",
          "quantity_adjustment_sets",
          "supply_air",
          "wall_ceiling_or_duct_installation",
        ],
      },
    ],
    filterCharacteristics: [
      "multienum",
      {
        values: [
          "accessible",
          "adjustable_blades",
          "adjustable_control_blades",
          "atex",
          "dual_duct_air_terminal_unit",
          "fixed_blades",
          "fixed_control_blades",
          "high_acoustic_requirements",
          "linear_grille",
          "low_flow_rate",
          "low_leakage_shut_off",
          "low_sound_power_level",
          "motor_actuated_adjustable",
          "perforated_front_plate",
          "thermal_adjustable",
          "varying_heat_loads",
        ],
      },
    ],
    filterDesign: [
      "multienum",
      {
        values: [
          "circular",
          "circular_square",
          "horizontal_blade_arrangement",
          "square",
          "vertical_blade_arrangement",
        ],
      },
    ],
    filterMaterial: [
      "multienum",
      { values: ["aluminium", "aluminium_steel", "plastic", "steel"] },
    ],
    filterSlideDepth: "string",
    filterSlideFlow: "string",
    filterSlideHeight: "string",
    filterSlideSoundPressure: "string",
    filterSlideWidth: "string",
    header: "string",
    image: ["referencelist", { only: ["Image"] }],
    introductionComplementaryText: "html",
    introductionImage: ["referencelist", { only: ["Image"] }],
    introductionText: "html",
    introductionTitle: "string",
    largeTab1Image: ["referencelist", { only: ["Image"] }],
    largeTab1Text: "html",
    largeTab1Title: "string",
    largeTab2Image: ["referencelist", { only: ["Image"] }],
    largeTab2Text: "html",
    largeTab2Title: "string",
    largeTab3Image: ["referencelist", { only: ["Image"] }],
    largeTab3Text: "html",
    largeTab3Title: "string",
    largeTab4Image: ["referencelist", { only: ["Image"] }],
    largeTab4Text: "html",
    largeTab4Title: "string",
    largeTab5Image: ["referencelist", { only: ["Image"] }],
    largeTab5Text: "html",
    largeTab5Title: "string",
    largeTab6Image: ["referencelist", { only: ["Image"] }],
    largeTab6Text: "html",
    largeTab6Title: "string",
    largeTabBoxTitle: "string",
    navigationTitle: "string",
    searchTitle: "string",
    productInfoComment: "string",
    productInfoDimensions: "string",
    productInfoFlow: "string",
    productInfoFormat: "string",
    productInfoMaterial: "string",
    productInfoText1: "string",
    productInfoText2: "string",
    promoHeader: "string",
    promoText: "string",
    smallTab1Text: "html",
    smallTab1Title: "string",
    smallTab2Text: "html",
    smallTab2Title: "string",
    smallTab3Text: "html",
    smallTab3Title: "string",
    title: "string",
    uuid: "string",
    documents: "referencelist",
    epfId: "string",
    erpNumber: "string",
    filterJson: "string",
    erpNumbers: "string",
    body: "html",
    ogDescription: "string",
    categorySegments: ["multienum", { values: categoriesProducts.segments }],
    categorySubsegments: [
      "multienum",
      { values: categoriesProducts.subsegments },
    ],
    categoryGroups: ["multienum", { values: categoriesProducts.groups }],
    categorySeries: ["multienum", { values: categoriesProducts.series }],
    linkedSpareParts: ["referencelist", { only: ["ProductSparePart"] }],
    ...metadataAttributes,
  },
  extractTextAttributes: ["body"],
});

export default ProductSeries;
